import {Disclosure} from "@headlessui/react";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import {useTranslation} from "next-i18next";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {ScreenNumber, useMediaQuery} from "../../hooks/useMediaQuery";
import IconFacebook from "../../data/Icons/leon-inmobiliaria-icons-facebook.svg";
import IconInsta from "../../data/Icons/leon-inmobiliaria-icons-instagram.svg";
import IconYoutube from "../../data/Icons/leon-inmobiliaria-icons-youtube.svg";
import HomeMap from "./HomeMap"

interface FooterProps {
}

function Footer({}: FooterProps) {
	const {currentScreenAsNumber, currentScreen} = useMediaQuery();

	const {t} = useTranslation();

	if (currentScreenAsNumber == null) {
		return <></>;
	}

	return (
		<>
			<HomeMap />
			
			<div className="flex flex-col xl:flex-row items-center bg-white text-black xl:justify-center xl:place-items-start xl:pt-16 xl:gap-10 xl:px-20 xl:pb-8">
				<div
					id="2"
					className="flex flex-col items-center xl:gap-y-4 pt-4 pb-0 xl:pt-0 xl:pb-0 xl:items-start xl:justify-start w-full xl:order-4"
				>
					<p className="font-bold text-base tracking-wider xl:pb-2 xl:w-full xl:max-w-[180px] uppercase">
						{t("footer.kontakt")}
					</p>
					<div className="flex flex-col items-center xl:gap-y-0 xl:items-start">
						<p className="text-base">{t("consts.address.line1")}</p>
						<p className="text-base">{t("consts.address.line2")}</p>
						<p className="text-base">{t("consts.address.line3")}</p>
						<p className="text-base">{t("consts.address.line4")}</p>
						<p className="text-base">{t("consts.address.line5")}</p>
						<p className="text-base xl:mt-4">
							{t("common.phoneShort")}: {t("consts.contact.tel")}
						</p>
						<p className="text-base xl:mt-4 text-nowrap">
							{t("consts.contact.info")}
						</p>
						<p className="text-base text-nowrap">
							{t("consts.contact.website")}
						</p>
					</div>
				</div>
				<div className="flex flex-col items-center xl:gap-4 py-4 xl:py-0 xl:w-full xl:items-start xl:order-6">
					<p className="font-bold text-base xl:tracking-wider xl:pb-2  xl:w-full xl:max-w-[180px] uppercase">
						{t("footer.follow_us")}
					</p>
					<div className="flex flex-col xl:gap-0 items-center xl:items-start justify-center">
									{/* <a
						className="h-14 w-14"
						href="https://twitter.com/IEON_INMO"
						target="_blank"
						rel="noopener noreferrer"
						>
						<IconTwitter />
						</a> */}
						<a
							className="text-black text-base"
							href="https://www.instagram.com/leon_inmobiliaria/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Instagram
						</a>
						<a
							className="text-black text-base"
							href="https://www.facebook.com/leonempuriabrava"
							target="_blank"
							rel="noopener noreferrer"
						>
							facebook
						</a>
						<a
							className="text-black text-base"
							href="https://www.youtube.com/@leoninmobiliaria9599"
							target="_blank"
							rel="noopener noreferrer"
						>
							Youtube
						</a>
					</div>
				</div>
				{[
					{
						buttonText: t("footer.immobilien.title"),
						panelItems: [
							{
								text: t("footer.immobilien.rent"),
								href: "/vermietung"
							},
							{
								text: t("footer.immobilien.sale"),
								href: "/verkauf"
							}
						],
						order: "",
						customChild: false,
						openInNewTab: false
					},
					{
						buttonText: t("footer.erlebnisse.title"),
						panelItems: [
							{
								text: "Empuriabrava",
								href: "#"
							},
							{
								text: "Sky Dive",
								href: "https://skydiveempuriabrava.com"
							},
							{
								text: "Minigolf Carmanso",
								href: "https://www.minigolfcarmanso.com"
							},
							{
								text: "Karting Empuriabrava",
								href: "https://kartingempuriabrava.com"
							},
							{
								text: "Casa Museo Salvador Dalí",
								href: "https://www.salvador-dali.org/es/visita/casa-salvador-dali"
							},
							{
								text: "Teatro Museo Salvador Dalí",
								href: "https://www.salvador-dali.org/es"
							},
							{
								text: "Casino Peralada",
								href: "https://www.casinoperalada.com"
							},
							{
								text: "Windoor",
								href: "https://www.windoor-realfly.com"
							},
							{
								text: "Aerodrome",
								href: "#"
							}
						],
						order: "",
						customChild: false,
						openInNewTab: true
					},
					{
						buttonText: "",
						panelItems: [
							{
								text: "Eco Boats",
								href: "https://ecoboats.es"
							},
							{
								text: "Los Barkitos",
								href: "https://losbarkitos.com"
							},
							{
								text: "Canal i Mar",
								href: "https://canalsimar.com"
							},
							{
								text: "Aiguamolls",
								href: "https://aiguamollsdelemporda.cat"
							},
							{
								text: "Aquabrava",
								href: "http://www.aquabrava.com"
							},
							{
								text: "Pitch and Putt",
								href: "https://golfcastello.com/en/golf-castello-empuriabrava-en"
							},
							{
								text: "Golf Club Peralada",
								href: "https://www.golfperalada.com"
							},
							{
								text: "Butterfly Park",
								href: "https://www.butterflypark.es"
							},
							{
								text: t("footer.bringBoats"),
								href: "#"
							}
						],
						order: "",
						customChild: false,
						openInNewTab: true
					},
					{
						buttonText: t("common.aboutUs"),
						panelItems: [
							{
								text: t("common.propertyManagement"),
								href: "/ueber-uns#immobilienverwaltung"
							},
							{
								text: t("footer.unserTeam"),
								href: "/ueber-uns#unserteam"
							},
							{
								text: t("aboutUs.s2.heading"),
								href: "/ueber-uns#poolpflege"
							},
							{
								text: t("aboutUs.s3.heading"),
								href: "/ueber-uns#reinigungsservice"
							},
							{
								text: "RENTWARE",
								href: "/grills-und-mehr"
							},
							{
								text: t("pages.contact.form.title"),
								href: "/ueber-uns#contact"
							}
						],
						order: "",
						customChild: false,
						openInNewTab: false
					}
				].map((item, index) =>
					currentScreenAsNumber > ScreenNumber.xl ? (
						<div
							key={index + item.buttonText}
							className={`w-full flex flex-col items-start justify-start gap-4 pb-8 ${item.order}`}
						>
							<p className="font-bold text-base xl:pb-2 xl:w-full xl:max-w-[200px] uppercase min-h-[32px]">
								{item.buttonText}
							</p>
							<div className="text-gray-500 pb-3 [&>*]:text-base [&>*]:text-black flex flex-col items-start gap-y-0 w-full">
								{item.customChild
									? item.customChild
									: item.panelItems.map((panelItem, idx) => (
										<Link key={panelItem.href + idx} href={panelItem.href} target={item.openInNewTab ? "_blank" : "_self"}>
											{panelItem.text}
										</Link>
									))}
							</div>
						</div>
					) : (
						<Disclosure
							as="div"
							className={`w-full`}
							key={index + item.buttonText}
							defaultOpen={true}
						>
							{({open}) => (
								<div className="w-full ">
									<Disclosure.Button className="py-0 flex items-center justify-center w-full text-left px-7">
										<p className="text-base font-bold uppercase text-center">
											{item.buttonText}
										</p>
									</Disclosure.Button>
									<Disclosure.Panel className="text-black px-7 pb-3 [&>*]:text-base [&>*]:text-black flex flex-col items-center gap-y-0 w-full">
										{item.customChild
											? item.customChild
											: item.panelItems.map((panelItem, idx) => (
												<Link key={panelItem.href + idx} href={panelItem.href}>
													{panelItem.text}
												</Link>
											))}
									</Disclosure.Panel>
								</div>
							)}
						</Disclosure>
					)
				)}
				<div
					className="flex flex-col items-center xl:gap-y-4 pt-4 pb-0 xl:pt-0 xl:pb-0 xl:items-start xl:justify-start w-full order-7"
				>
					<p className="font-bold text-base tracking-wider xl:pb-2 xl:w-full xl:max-w-[220px] uppercase">
						{t("footer.certified")}
					</p>
					<div className="flex flex-col items-center xl:gap-y-0 xl:items-start">
						<div className="mt-4">
							<Image
								quality={90}
								src="/images/letrero-api-6835.jpg"
								alt=""
								width={500}
								height={500}
								className="w-32 xl:w-40"
							/>
						</div>
					</div>
				</div>
			</div>
			<div className="flex flex-col-reverse items-center gap-y-4 pt-4 bg-white xl:bg-[#b8aa95] w-full h-full pb-16 xl:flex-row xl:justify-center xl:py-5 xl:px-24 gap-6">
				<p className="text-base text-black xl:text-white uppercase">
					© COPYRIGHT {t("consts.companyName")} 2025
				</p>
				<div className="flex [&>*]:text-base [&>*]:text-black xl:[&>*]:text-white [&>*]:font-bold flex-col gap-y-0 items-center xl:flex-row xl:gap-x-6">
					<Link className="uppercase" href="/impressum">{t("footer.legal")}</Link>
					<Link className="uppercase" href="/datenschutz">{t("footer.privacy")}</Link>
					<Link className="uppercase" href="/agb">{t("footer.terms")}</Link>
				</div>
			</div>
		</>
	);
}

export default Footer;
